module.exports = __webpack_public_path__ + "static/functions-screen-4-d852347c51be7f8ff07e168a7f6d5f7e.png";